module.exports = __webpack_public_path__ + "static/media/angle-down.7deefba2.svg";